import { connect } from 'react-redux';
import TagSearchByVehicleNo from './tagSearchByVehicleNo';
import { bindActionCreators } from 'redux';
import { tagSearchByVehicleNo,auditLogs } from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
    tagInfo: state.siteListingReducer.tagInfoByVehicleNumber,
    tagAudit: state.siteListingReducer.tagAudit
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      tagSearchByVehicleNo,
      auditLogs
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(TagSearchByVehicleNo);
